import React, { useState } from 'react';
import { Phone, ArrowRight } from 'lucide-react';

const Header = ({ onOpenEnquiry, onOpenApply }) => {
  const [imgError, setImgError] = useState(false);

  return (
    <header className="site-header">
      <div className="header-container">
        <div className="logo-wrapper">
          {!imgError ? (
            <img
              src="/logo.webp"
              alt="Online Manipal"
              className="site-logo-img"
              onError={() => setImgError(true)}
            />
          ) : (
            <div className="logo-badge">
              <span className="logo-online">ONLINE</span>
              <span className="logo-manipal">MANIPAL</span>
            </div>
          )}
        </div>

        <nav className="header-nav">
          <div className="helpline">
            <Phone size={18} className="helpline-icon" />
            <a href="tel:+917631900600">+91 7631 900 600</a>
          </div>

          <button className="btn-secondary nav-enquire-btn" onClick={onOpenEnquiry}>
            Enquire Now
          </button>

          <button className="btn-primary nav-apply-btn" onClick={onOpenApply}>
            Apply Now <ArrowRight size={16} style={{ marginLeft: '4px' }} />
          </button>
        </nav>
      </div>
    </header>
  );
};

export default Header;
